import api from './api';

export interface ServerSetting {
  key: string;
  value: string | null;
  /** The value the setting takes while none is stored; null or empty when a missing value leaves it off or unset. */
  defaultValue: string | null;
  /** Why the server refuses the stored value; null while none is stored or the stored one is valid. */
  valueError: string | null;
}

export async function getServerSettings(): Promise<ServerSetting[]> {
  const response = await api.get<ServerSetting[]>('admin/server-settings');
  return response.data;
}

export async function setServerSetting(key: string, value: string): Promise<ServerSetting> {
  const response = await api.put<ServerSetting>(`admin/server-settings/${encodeURIComponent(key)}`, { value });
  return response.data;
}
